import Vue from 'vue';
import Component from 'vue-class-component';
import { G2S } from 'core/g2s';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class DialogAppComponent extends Vue {
    onClose(): void {
        (<any>this).$refs.dialog.hide();
    }

    onApple() {
        (<any>this).$refs.dialog.hide();

        window.open('https://apps.apple.com/ru/app/mego-travel-%D0%B0%D0%B2%D0%B8%D0%B0%D0%B1%D0%B8%D0%BB%D0%B5%D1%82%D1%8B-%D0%B4%D0%B5%D1%88%D0%B5%D0%B2%D0%BE/id6444725059', '_blank');
    }
    
    onGoogle() {
        (<any>this).$refs.dialog.hide();

        window.open('https://play.google.com/store/apps/details?id=travel.mego.app', '_blank');
    }

    show() {
        if (G2S.config.locale === 'ru' && G2S.config.theme === 'mego') {
            (<any>this).$refs.dialog.show();
        }
    }
}
